import { CONDITION_TYPES } from "../constants";
import type { RiskRuleFormFields } from "../types";

export function validateFormValues(fields: RiskRuleFormFields) {
  const errors: Partial<Record<keyof RiskRuleFormFields, string>> = {};

  if (!fields.name) {
    errors.name = "Name is required";
  }

  if (!fields.risk_level) {
    errors.risk_level = "Risk level is required";
  }

  return errors;
}

export function validateConditions(conditions: Array<any>) {
  const hasEmptyConditionValue = Boolean(
    conditions.find((condition) => {
      const { resource_type, resource_data } = condition;

      if (!resource_type) {
        return true;
      }

      if (resource_type === CONDITION_TYPES.AMOUNT) {
        if (!resource_data?.operator) {
          return true;
        }

        if (!resource_data.value && resource_data.value !== 0) {
          return true;
        }

        if (!resource_data?.currency) {
          return true;
        }
      }

      if (
        [
          CONDITION_TYPES.EMAIL_ADDRESS,
          CONDITION_TYPES.EMAIL_DOMAIN,
          CONDITION_TYPES.IP_ADDRESS,
          CONDITION_TYPES.PHONE_NUMBER,
          CONDITION_TYPES.ZIP_CODE,
        ].includes(resource_type)
      ) {
        if (!resource_data?.bulk_lists?.length) {
          return true;
        }
      }

      return false;
    })
  );

  if (hasEmptyConditionValue) {
    return {
      valid: false,
      errorMessage: "Condition value cannot be left empty",
    };
  }

  return { valid: true, errorMessage: null };
}
